import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import ContextModal from '../context-modal';
import {
  RestrictedWrapper,
  Heading,
  Description,
  DescriptionStrong,
  DescriptionWrapper,
  IconUnrestricted,
  IconContainer
} from './styled';
import { LockIcon, UnlockIcon } from '../../helpers/icon-dictionary';
import SvgIcon from '../svg-icon/svg-icon';

const StudentAccessMenu = ({
  showMenu,
  positionX,
  positionY,
  isRestricted,
  i18n,
  handleChange,
  setContextMenu
}) => {
  const changeRestriction = (setRestriction) => {
    setContextMenu(false);
    handleChange(setRestriction);
  };

  const openHeader = i18n._(
    t('studentAccessMenu.openAccess')`Student Open Access`
  );
  const closedHeader = i18n._(
    t('studentAccess.studentsOnTask')`Students On Task`
  );

  return (
    <ContextModal
      show={showMenu}
      flowUp
      modalBottom
      positionX={positionX}
      positionY={positionY}
    >
      <>
        <RestrictedWrapper
          data-testid="unrestricted-wrapper"
          onClick={() => changeRestriction(false)}
        >
          <DescriptionWrapper>
            <Heading data-testid="unrestricted-header">{openHeader}</Heading>
            <Description data-testid="unrestricted-description">
              {i18n._(
                t('studentAccess.accessToMathleticsFirst')`Students have `
              )}
              <DescriptionStrong>
                {i18n._(t('studentAccess.independent')`independent`)}
              </DescriptionStrong>
              {i18n._(
                t(
                  'studentAccess.accessToMathleticsLast'
                )` access to all areas of Mathletics.`
              )}
            </Description>
          </DescriptionWrapper>
          <IconContainer>
            <IconUnrestricted
              data-testid="button-update-restriction"
              isRestricted={isRestricted}
            >
              <SvgIcon icon={UnlockIcon} />
            </IconUnrestricted>
          </IconContainer>
        </RestrictedWrapper>
        <RestrictedWrapper
          data-testid="restricted-wrapper"
          onClick={() => changeRestriction(true)}
        >
          <DescriptionWrapper>
            <Heading data-testid="restricted-header">{closedHeader}</Heading>
            <Description data-testid="restricted-description">
              {i18n._(
                t(
                  'studentAccess.restrictedBody'
                )`Students are restricted to assigned activities showing in their To Do list. Students can still access Meritopia`
              )}
            </Description>
          </DescriptionWrapper>
          <IconContainer>
            <IconUnrestricted isRestricted={isRestricted}>
              <SvgIcon icon={LockIcon} />
            </IconUnrestricted>
          </IconContainer>
        </RestrictedWrapper>
      </>
    </ContextModal>
  );
};

StudentAccessMenu.propTypes = {
  showMenu: PropTypes.bool.isRequired,
  isRestricted: PropTypes.bool.isRequired,
  positionX: PropTypes.number,
  positionY: PropTypes.number,
  i18n: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  setContextMenu: PropTypes.func.isRequired
};

export default StudentAccessMenu;



// WEBPACK FOOTER //
// ./components/student-access/student-access-menu.js